import { render, staticRenderFns } from "./agent-carousel.vue?vue&type=template&id=640dce18&scoped=true"
import script from "./agent-carousel.vue?vue&type=script&lang=js"
export * from "./agent-carousel.vue?vue&type=script&lang=js"
import style0 from "./agent-carousel.vue?vue&type=style&index=0&id=640dce18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640dce18",
  null
  
)

export default component.exports